// removed by extract-text-webpack-plugin
module.exports = {"root":"_XtTg-","socialList":"_1JFlr","icon":"_2jGw9"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/SocialMedia.scss
// module id = 1186
// module chunks = 2